import { render, staticRenderFns } from "./manybo-section.vue?vue&type=template&id=08713304&scoped=true"
import script from "./manybo-section.vue?vue&type=script&lang=js"
export * from "./manybo-section.vue?vue&type=script&lang=js"
import style0 from "./manybo-section.vue?vue&type=style&index=0&id=08713304&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08713304",
  null
  
)

export default component.exports